export default function responsibleStudentColumns(t) {
  return [
    { title: t('general.name'), field: 'responsible.fullName' },
    { title: t('general.bond'), field: 'typeDescription' },
    {
      title: t('general.access-student-data'),
      field: 'accessStudentDataDescription',
    },
    { title: t('general.take-student'), field: 'takeStudentDescription' },
    {
      title: t('general.financial-contact'),
      field: 'financialContactDescription',
    },
    {
      title: t('general.emergency-contact'),
      field: 'emergencyContactDescription',
    },
    { title: t('general.phones'), field: 'phones' },
    { title: t('general.email'), field: 'responsible.email' },
  ];
}
